app.factory('visitCardModel', ['$rootScope', '$q', 'baseModel', 'visitCardService', 'config',
    function($rootScope, $q, baseModel, visitCardService, config) {

        function VisitCardModel() {

            this.downloadPDF = function(idVisitCard) {
                var pdfWindow = window.open(config.API_URL + '/visitCards/' + idVisitCard + "/pdf/download", '_blank');
                pdfWindow.addEventListener('load', function () {
                    pdfWindow.print();
                }, false);

            };

            this.previewPDF = function(idVisitCard) {
                window.open(config.API_URL + '/visitCards/' + idVisitCard + "/pdf/preview", '_blank');
            };

            this.getById = function(id) {
                return visitCardService.getById(id).then(
                    function (user) {
                        $rootScope.$broadcast(Event.VISIT_CARD.GET_BY_ID.SUCCESS, user);
                        return user;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.VISIT_CARD.GET_BY_ID.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.getP1ById = function(id) {
                return visitCardService.getP1ById(id).then(
                    function (prescriptionHTML) {
                        $rootScope.$broadcast(Event.VISIT_CARD.GET_BY_ID.SUCCESS, prescriptionHTML);
                        return prescriptionHTML;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.VISIT_CARD.GET_BY_ID.ERROR, error);
                        return $q.reject(error);
                    }
                );
            };

            this.getEReferralById = function(id, fullVersion) {
                return visitCardService.getEReferralById(id, fullVersion).then(
                    function (referralHTML) {
                        $rootScope.$broadcast(Event.VISIT_CARD.GET_E_REFERRAL_BY_ID.SUCCESS, referralHTML);
                        return referralHTML;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.VISIT_CARD.GET_E_REFERRAL_BY_ID.ERROR, error);
                        return $q.reject(error);
                    }
                );
            };

            this.deleteEReferral = function(id, password) {
                return visitCardService.deleteEReferral(id, password).then(
                    function (data) {
                        return data;
                    },
                    function(error) {
                        return $q.reject(error);
                    }
                );
            };


            this.save = function(visitCard) {
                return visitCardService.save(visitCard).then(
                    function (savedVisitCard) {
                        $rootScope.$broadcast(Event.VISIT_CARD.SAVE.SUCCESS, savedVisitCard);
                        baseModel.broadcastOperationSucceeded();
                        return savedVisitCard;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.VISIT_CARD.SAVE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                        return $q.reject(error);
                    }
                )
            };

            this.update = function(visitCard) {
                return visitCardService.update(visitCard).then(
                    function (updatedVisitCard) {
                        $rootScope.$broadcast(Event.VISIT_CARD.UPDATE.SUCCESS, updatedVisitCard);
                        baseModel.broadcastOperationSucceeded();
                        return updatedVisitCard;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.VISIT_CARD.UPDATE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                        return $q.reject(error);
                    }
                )
            };

            this.startStreamRecording = function(id) {
                return visitCardService.startStreamRecording(id).then(
                    function (streamingSessionId) {
                        $rootScope.$broadcast(Event.VISIT_CARD.START_STREAM_RECORDING.SUCCESS, streamingSessionId);
                        return streamingSessionId;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.VISIT_CARD.START_STREAM_RECORDING.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.stopStreamRecording = function(id) {
                return visitCardService.stopStreamRecording(id).then(
                    function (streamingSessionId) {
                        $rootScope.$broadcast(Event.VISIT_CARD.STOP_STREAM_RECORDING.SUCCESS, streamingSessionId);
                        return streamingSessionId;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.VISIT_CARD.STOP_STREAM_RECORDING.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.downloadVideoConsultation = function (id) {
                window.open(config.API_URL + '/streaming/' + id + '/download','_blank');
            };

            this.updateTextFields = function (visitCardId, visitCardTextFieldsWrapper) {
                return visitCardService.updateTextFields(visitCardId, visitCardTextFieldsWrapper).then(
                    function (response) {
                        return response;
                    },
                    function(error) {
                        baseModel.broadcastOperationFailed();
                        return $q.reject(error);
                    }
                )
            };


        }

        return new VisitCardModel();
    }
]);
